import ContentEntity from './content-entity.js';

/**
 * CategoryEntity — one category (/categories + /categories/:slug).
 * Categories group services; `parentId` allows a hierarchy (null = top level).
 */
class CategoryEntity extends ContentEntity {
    static TYPE = 'categories';
    static S3_PATH = 'content.categories';

    static EMPTY = {
        id: '',
        parentId: null,
        slug: '',
        status: true,
        popular: false,
        name: '',
        title: '',
        subtitle: '',
        description: '',
        image: '',
        media: '',
        ctaText: '',
        items: [],
        seo: { title: '', description: '', keywords: '', image: '' },
        source: 'local',
        externalId: null,
    };

    constructor(raw = {}) {
        super(raw);
        const R = CategoryEntity.resolveImg;
        this.image = R(raw.image) || null;
        this.media = R(raw.media) || this.image;
    }

    isTopLevel() {
        return !this.parentId;
    }
}

export default CategoryEntity;
